import React from 'react';
import { connect } from 'react-redux';
import MintingRow from './MintingRow';

const mapStateToProps = (state) => {
  return {
    coinsMinted: state.coinsMinted
  };
};

const connectedLatestCoinsBought = ({coinsMinted}) => (
  <div className="c-component c-coins-bought">
    <h2>Latest Coins Bought</h2>
    <ul className="c-coins-bought__list">
      {coinsMinted
        .reverse()
        .slice(0, 10)
        .map((coinsMintedEvent) => (
          <li key={coinsMintedEvent.transactionHash} className="c-coins-bought__list-item">
            <MintingRow coinsMinted={coinsMintedEvent}/>
          </li>
        ))}
    </ul>
  </div>
);

const LatestCoinsBought = connect(mapStateToProps)(connectedLatestCoinsBought);

export default LatestCoinsBought;



// WEBPACK FOOTER //
// ./src/components/AnalyticsPage/LatestCoinsBought.js